import { render, staticRenderFns } from "./OrdersAudit.vue?vue&type=template&id=c64fd562&scoped=true&"
import script from "./OrdersAudit.vue?vue&type=script&lang=js&"
export * from "./OrdersAudit.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAudit.vue?vue&type=style&index=0&id=c64fd562&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64fd562",
  null
  
)

export default component.exports